/* ══════════════════════════════════════════════════════════════════
   [D-771] «🎨 Теми, дані особисто» — у картці юзера.

   OWNER 30.10 («дані йому особисто - Так»): тему, яку власник дав юзеру
   ОСОБИСТО («👤 Юзеру…» у «🧪 Дозволи і Теми», D-765), досі видно було лише
   в Студії самого юзера. Тут — список таких тем (свої теми власника і
   вбудовані) і «✕ Забрати». Що юзеру дав партнер — не тут і не чіпається.

   Блок мовчить, коли особистих тем немає.
   ══════════════════════════════════════════════════════════════════ */
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import api from '../api';

const C = { card: '#1b2836', line: 'rgba(179,157,219,.35)', txt: '#eaf6ff', dim: '#a8bece', acc: '#c4b5fd' };

export default function UserThemesGiven({ userId, onChanged }) {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState('');
  const [ask, setAsk] = useState('');
  useEffect(() => {
    let dead = false; setItems(null);
    api.get(`/users/${userId}/themes-given`).then(r => { if (!dead) setItems((r.data && r.data.items) || []); }).catch(() => { if (!dead) setItems([]); });
    return () => { dead = true; };
  }, [userId]);
  if (!items || !items.length) return null;
  const take = (it) => {
    const k = it.kind + ':' + it.id;
    if (ask !== k) { setAsk(k); return; }
    setBusy(k); setAsk('');
    api.post(`/users/${userId}/themes-given/revoke`, { kind: it.kind, id: it.id })
      .then(r => { setItems((r.data && r.data.items) || []); onChanged && onChanged(); })
      .catch(e => alert('Не вдалось: ' + ((e.response && e.response.data && e.response.data.detail) || e.message)))
      .finally(() => setBusy(''));
  };
  return (
    <Box data-utg="box" sx={{ mb: 2, p: 1.4, borderRadius: 2, border: `1px solid ${C.line}`, bgcolor: 'rgba(179,157,219,.05)' }}>
      <Typography sx={{ color: C.txt, fontWeight: 800, fontSize: 14.5 }}>
        🎨 Теми, дані особисто: {items.length}
        <span style={{ color: C.dim, fontWeight: 600, fontSize: 12.5 }}> · видно в його Студії незалежно від рішення партнера</span>
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: .8, mt: 1 }}>
        {items.map(it => {
          const k = it.kind + ':' + it.id;
          return (
            <Box key={k} data-utg-item={k} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: .5, borderRadius: 2, bgcolor: C.card, border: '1px solid rgba(255,255,255,.08)' }}>
              <Typography sx={{ fontSize: 13, color: C.txt, fontWeight: 700 }}>
                {it.icon} {it.name}
                <span style={{ color: C.dim, fontWeight: 500, fontSize: 11.5 }}> · {it.kind === 'slot' ? 'вбудована' : 'ваша тема'}</span>
              </Typography>
              <Button size="small" data-utg-take={k} disabled={!!busy} onClick={() => take(it)}
                sx={{ minWidth: 0, px: 1, py: .1, fontSize: 11.5, textTransform: 'none', color: ask === k ? '#fff' : '#f87171',
                      bgcolor: ask === k ? 'rgba(248,113,113,.35)' : 'transparent', border: '1px solid rgba(248,113,113,.45)' }}>
                {busy === k ? '…' : ask === k ? 'Точно забрати?' : '✕ Забрати'}
              </Button>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
